import { SVGProps } from 'react';

const Map = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 3.236a2 2 0 0 0-.894.211L3.553 5.724A1 1 0 0 0 3 6.618v12.763a1 1 0 0 0 1.447.897l3.659-1.83a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l4.553-2.277a1 1 0 0 0 .553-.894V4.619a1 1 0 0 0-1.447-.896l-3.659 1.83a2 2 0 0 1-1.788 0L9.894 3.447A2 2 0 0 0 9 3.237m6 2.528v15M9 3.236v15"
    />
  </svg>
);
export default Map;
